import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { boardGroupsService } from '../api/board-groups.service';
import { BOARD_KEYS } from './queryKeys';

export function useBoardGroups(boardId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: BOARD_KEYS.groups(orgId ?? '', boardId),
    queryFn: ({ signal }) => boardGroupsService.getByBoard(boardId, signal),
    staleTime: 300_000,
    enabled: !!orgId && !!boardId,
  });

  return {
    groups: data?.data ?? [],
    isLoading,
    isError,
  };
}
